<div class="vehicle-not-found" *ngIf="show">

  <div class="icon-container">
    <i class="app-icon-car-alt"></i>
    <i class="material-icons">help</i>
  </div>
  <h1>
    Ops… Veículo não encontrado.
  </h1>
  <h2>
    Parece que o veículo que você está procurando não está mais disponível.
  </h2>
  <div class="button-container">
    <a [routerLink]="routerLink" class="btn btn-branded5 text-white btn-lg btn-rounded">
      VER TODOS OS VEÍCULOS
    </a>
  </div>
</div>